import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';

import Sidebar from './components/Sidebar';
//import Footer from './components/Footer';
import Guide from './pages/Guide';  // About 컴포넌트
//import Home from './pages/Home';    // Home 컴포넌트
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import TopNav from './components/Navbar';

export default function App() {
  return (
    <div className="app-container">
      <Sidebar />
      <main className='container mx-auto p-3'>
        <TopNav />
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Dashboard />} />
            <Route path="/Guide" element={<Guide />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </Router>
      </main>
      {/* <Footer /> */}
    </div>
  );
}
